import { MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DASHBOARD_COLORS } from './statusDashboardStyles';

export type PillSelectOption = string | { value: string; label: string };

interface PillSelectProps {
  label: string;
  value: string;
  options: PillSelectOption[];
  onChange: (value: string) => void;
}

export const usePillSelectStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    height: 40,
    padding: '0 16px',
    background: DASHBOARD_COLORS.card,
    border: `1px solid ${DASHBOARD_COLORS.border}`,
    borderRadius: 32,
    fontSize: 13,
  },
  label: {
    color: DASHBOARD_COLORS.muted,
  },
  select: {
    fontSize: 13,
    fontWeight: 700,
    '&:focus': {
      background: 'transparent',
    },
  },
}));

export const PillSelect = ({ label, value, options, onChange }: PillSelectProps) => {
  const classes = usePillSelectStyles();
  return (
    <div className={classes.root}>
      <span className={classes.label}>{label}</span>
      <Select
        value={value}
        disableUnderline
        classes={{ select: classes.select }}
        onChange={e => onChange(e.target.value as string)}
      >
        {options.map(option => {
          const { value: optionValue, label: optionLabel } = typeof option === 'string' ? { value: option, label: option } : option;
          return (
            <MenuItem key={optionValue} value={optionValue}>
              {optionLabel}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};
